import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { UseMutationOptions } from 'react-query'
import { BaseApiResponse } from '../../../api/shared'
import {
  addIpToBlockList,
  AddIpToBlockListArgs
} from './requests/add-ip-to-block-list'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export interface UseAddIpToBlockListResult {
  mutate: (
    variables: AddIpToBlockListArgs,
    options?: UseMutationOptions<BaseApiResponse, Error, AddIpToBlockListArgs>
  ) => void
  isSuccess: boolean
  isError: boolean
  error: Error | null
  data: BaseApiResponse | undefined
}

export function useAddIpToBlockList(
  options?: UseMutationOptions<BaseApiResponse, Error, AddIpToBlockListArgs>
): UseAddIpToBlockListResult {
  const { mutate, isSuccess, data, error, isError } = useContrastMutation<
    BaseApiResponse,
    HTTPError,
    AddIpToBlockListArgs
  >(addIpToBlockList, options)

  return { mutate, isSuccess, data, error, isError }
}
